import courses from './routes'

export default [...courses] as const
